export const GET_CUSTOMER_ID = 'GET_CUSTOMER_ID';
export const GET_CUSTOMER_ID_SUCCESS = 'GET_CUSTOMER_ID_SUCCESS';
export const GET_CUSTOMER_ID_ERROR = 'GET_CUSTOMER_ID_ERROR';
export const SUBMIT_IVR_FORM = 'SUBMIT_IVR_FORM';
export const SUBMIT_IVR_FORM_SUCCESS = 'SUBMIT_IVR_FORM_SUCCESS';
export const SUBMIT_IVR_FORM_ERROR = 'SUBMIT_IVR_FORM_ERROR';
